import { cloneDeep, get, set } from 'lodash';
import { KOSTEN_ARTEN, KOSTEN_POSITION, NACHWEIS_POSITION_STATUS } from 'src/lib/constants/constant';

// import Schemas
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
const MA_P = MittelabrufSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

export const executeStipendiumMAFormulas = (application: any) => {
	let appCopy = cloneDeep(application);
	let result: any = [];

	// let calculatedGesamt = calculateGesamt(appCopy);
	// result.push(...calculatedGesamt);
	// for (let ele of calculatedGesamt) {
	// 	set(appCopy, get(ele, 'path'), get(ele, 'value'));
	// }
	let calculatedFoerderung = calculateFoerderung(appCopy);
	result.push(...calculatedFoerderung);
	for (let ele of calculatedFoerderung) {
		set(appCopy, get(ele, 'path'), get(ele, 'value'));
	}

	return result;
};

export const calculateGesamt = (application: any) => {
	const result: any = {};
	// const angefalleneAusgaben = Number(get(application, MA_P.Stipendium_Angefallene_Ausgaben.path)) || 0;
	// const anfallendeAusgaben = Number(get(application, MA_P.Stipendium_Anfallende_Ausgaben.path)) || 0;
	// const gesamt = angefalleneAusgaben + anfallendeAusgaben;

	// const abzueglichPrivateEigenmittel = Number(get(application, MA_P.Stipendium_Abzuegl_Private_Eigenmittel.path)) || 0;
	// const abzueglichOeffentlichemittel = Number(get(application, MA_P.Stipendium_Abzuegl_Oeffentliche_Mittel.path)) || 0;
	// const bemessungsgrundlage = gesamt - abzueglichPrivateEigenmittel - abzueglichOeffentlichemittel;

	const nachweispositionen = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);
	const getAusgabenByStatus = (status: string) => {
		const nachweisposition = (nachweispositionen as any[]).find((eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
		return Number(get(nachweisposition, NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0;
	};
	const getEinnahmeByKostenart = (kostenart: string) =>
		(nachweispositionen as any[]).find(
			(eachPosition: any) =>
				get(eachPosition, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Einnahme &&
				get(eachPosition, NP_P.Allgemein_Kostenart_Finanzierung.path) === kostenart,
		);
	const eigenmittelBetrag = Number(get(getEinnahmeByKostenart(KOSTEN_ARTEN.Eigenmittel), NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0;
	const oeffentlicheMittelBetrag = Number(get(getEinnahmeByKostenart(KOSTEN_ARTEN.OeffentlicheMittel), NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0;
	const eigenUndDrittmittelGesamt = eigenmittelBetrag + oeffentlicheMittelBetrag;

	const angefalleneAusgaben = getAusgabenByStatus(NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const anfallendeAusgaben = getAusgabenByStatus(NACHWEIS_POSITION_STATUS.geplant);
	const gesamt = angefalleneAusgaben + anfallendeAusgaben;

	const bemessungsgrundlage = gesamt - eigenUndDrittmittelGesamt;
	result.gesamt = gesamt;
	result.bemessungsgrundlage = bemessungsgrundlage;

	return result;
};
export const calculateFoerderung = (application: any) => {
	let result: any = [];
	const foerderquote = Number(get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Foerderquote_Gesamt.path)) || 0;
	const berechneteSummen = calculateGesamt(application);
	const projektausgabenGesamt = Number(get(berechneteSummen, 'gesamt', 0)) || 0;
	const zuwendungAnteilig = projektausgabenGesamt * (foerderquote / 100);
	const foerderung = Number(get(application, MA_P.Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung.path, 0)) || 0;
	const bereitsAusgezahlt = Number(get(application, MA_P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path, 0)) || 0;
	const verfuegbareFoerderungDiesesHaushaltsjahr = Math.max(0, foerderung - bereitsAusgezahlt);
	const bemessungsgrundlage = Number(get(berechneteSummen, 'bemessungsgrundlage', 0)) || 0;
	const berechneteMaxFoerderung = Math.max(0, Math.min(bemessungsgrundlage - bereitsAusgezahlt, verfuegbareFoerderungDiesesHaushaltsjahr));
	result.push(
		{
			path: MA_P.Zuwendung_Anteilig_Gesamt.path,
			value: !isNaN(zuwendungAnteilig) ? zuwendungAnteilig.toFixed(2) : 0,
		},
		{
			path: MA_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path,
			value: !isNaN(zuwendungAnteilig) ? zuwendungAnteilig.toFixed(2) : 0,
		},
		{
			path: MA_P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path,
			value: !isNaN(berechneteMaxFoerderung) ? berechneteMaxFoerderung.toFixed(2) : 0,
		},
	);

	return result;
};
